import { yup } from '@guiker/shared-framework'

import { maxDepositAmount } from '../../../../entity'

export const createDepositSchema = yup.object({
  payInMethodId: yup.string().required(),
  amount: yup.number().positive().max(maxDepositAmount.CAD).required(),
})
